import { TvBaseColumns } from './TvBaseColumns';
class _TvOrderHistoryColumns extends TvBaseColumns {
    getOrderHistoryColumns() {
        const date = this.createColumnItem('panel.orders.date_time', 'date', "localDateOrDateTime" /* StandardFormatterName.LocalDateOrDateTime */);
        const symbol = this.createColumnItem('panel.orders.symbol', 'symbol', "symbol" /* StandardFormatterName.Symbol */);
        const side = this.createColumnItem('panel.orders.action', 'side', "side" /* StandardFormatterName.Side */);
        const type = this.createColumnItem('panel.orders.type', 'type', "type" /* StandardFormatterName.Type */, false, [
            'type',
            'parentId',
            'stopType'
        ]);
        const qty = this.createColumnItem('panel.orders.quantity', 'qty', "formatQuantity" /* StandardFormatterName.FormatQuantity */);
        const limitPrice = this.createColumnItem('panel.orders.price', 'limitPrice', "formatPrice" /* StandardFormatterName.FormatPrice */);
        const stopPrice = this.createColumnItem('panel.orders.StopPrice', 'stopPrice', "formatPrice" /* StandardFormatterName.FormatPrice */);
        const tif = this.createColumnItem('panel.orders.TIF', 'tif', "text" /* StandardFormatterName.Text */);
        const status = this.createColumnItem('panel.orders.Status', 'status', "status" /* StandardFormatterName.Status */);
        const id = this.createColumnItem('panel.orders.Reference', 'id', "text" /* StandardFormatterName.Text */);
        return [date, symbol, side, type, qty, limitPrice, stopPrice, tif, status, id];
    }
}
export const TvOrderHistoryColumns = new _TvOrderHistoryColumns();
